<template>
  <section
    :class="[
      'common-header-wrapper',
      'flex-col-center',
      type,
      fissionGame,
      displayLayout,
    ]"
  >
    <!-- 分享者弹窗头部 -->
    <template v-if="type === 'isOwner'">
      <p class="title flex-center">
        <span>{{ title }}</span>
      </p>
      <div class="notice-wrapper">
        <van-notice-bar :scrollable="false" wrapable>
          <van-swipe
            vertical
            class="score-swipe"
            :autoplay="1500"
            :show-indicators="false"
            :touchable="false"
          >
            <van-swipe-item v-for="(item, index) in dataSource" :key="index"
              >{{ item }}
            </van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </div>
    </template>
    <!-- 被分享者弹窗头部 -->
    <template v-else>
      <p class="title flex-center">
        <span>{{ title }}</span>
      </p>
      <div class="desc">
        {{ desc }}
      </div>
    </template>
  </section>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { dataSource as mockData } from '../components/DashBord/datas'

  export default {
    props: {
      type: {
        type: String,
        default: '',
      },
      awards: {
        type: [String, Number],
        default: '',
      },
      shareAward: {
        type: [String, Number],
        default: '',
      },
      loginAward: {
        type: [String, Number],
        default: '',
      },
      everyOneMaxAwardNum: {
        type: [String, Number],
        default: '',
      },
      swipeList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState(['fissionInfos', 'fissionGame']),
      ...mapGetters(['displayLayout']),
      dataSource() {
        return this.swipeList || mockData
      },
      title() {
        const { extraInfo } = this.fissionInfos || {}
        return this.type === 'isOwner'
          ? extraInfo?.noLoginShareTitle // 分享者
          : extraInfo?.noLoginToShareTitle // 被分享者标题 $t('fission.assist-friends-get-diamonds')
      },
      desc() {
        const { extraInfo } = this.fissionInfos || {}
        return extraInfo?.noLoginToShareDesc || ''
      },
    },
  }
</script>
<style lang="scss" scoped>
  .common-header-wrapper {
    color: #fff;
    text-align: center;
    font-family: 'MiSans', 'Noto Sans';
    font-weight: 600;
    box-sizing: border-box;
    position: relative;
    width: 100%;
    .page.notice-wrapper {
      font-size: 30px;
    }
    &.isOwner {
      height: 310px; // 定高，以便控制标题能居中显示
      .title {
        width: 100%;
        height: 240px;
        font-size: 48px;
        line-height: 59px;
        padding: 0 40px;
        box-sizing: border-box;
        .amount1,
        .amount2 {
          font-weight: 900;
          color: #ffea7b;
        }
        & > span {
          font-size: 48px;
          line-height: 59px;
          letter-spacing: 0px;
          text-align: center;
          @include canWrap($lineCount: 4);
        }
      }
      .notice-wrapper {
        width: 633px;
        height: 68px;
        background: #343434;
        border-radius: 74px;
        margin: 0 auto;
        margin-top: 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        box-sizing: border-box;
      }
      &.mobile-legends {
        .notice-wrapper {
          background: #1e1f71;
        }
      }
      &.genshin {
        .notice-wrapper {
          background: rgba(86, 93, 144, 1);
        }
      }
    }
    &.isGuest {
      .title {
        height: 250px;
        & > span {
          font-size: 55px;
          line-height: 100%;
          padding: 0 56px;
          box-sizing: border-box;
          @include canWrap($lineCount: 4);
        }
      }
      .desc {
        font-size: 35px;
        line-height: 42px;
        color: #fff;
        padding: 0 116px;
        box-sizing: border-box;
        margin-top: 28px;
        @include canWrap($lineCount: 3);
        .awardAmount {
          font-weight: 900;
          font-size: 40px;
          color: #ffea7b;
        }
        span {
          color: #fff;
        }
      }
    }
  }
</style>
<style scoped>
  .notice-wrapper >>> .van-notice-bar {
    height: 68px;
    background-color: unset;
    padding: 0;
  }
  .notice-wrapper >>> .van-notice-bar .van-notice-bar__wrap {
    display: flex;
    justify-content: center;
  }
  .notice-wrapper
    >>> .van-notice-bar
    .van-notice-bar__wrap
    .van-notice-bar__content {
    width: 100%;
  }
  .notice-wrapper >>> .van-notice-bar .score-swipe {
    height: 68px;
    line-height: 68px;
  }
  .notice-wrapper >>> .van-notice-bar .score-swipe .van-swipe__track {
    display: flex;
    justify-content: center;
    color: #ffffff;
    /* overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; */
  }
  .notice-wrapper
    >>> .van-notice-bar
    .score-swipe
    .van-swipe__track
    .van-swipe-item {
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-word;
    font-size: 22px;
    line-height: 29px;
  }
  .notice-wrapper >>> .van-swipe-item {
    font-size: 22px;
    line-height: 29px;
  }
  /* 针对 GT 模式的适配 */
  .isOwner.gt-layout .notice-wrapper >>> .van-notice-bar {
    height: 68px;
  }
  .isOwner.gt-layout .notice-wrapper >>> .van-swipe-item {
    font-size: 22px;
  }
  .isOwner.gt-layout .notice-wrapper >>> .van-notice-bar .score-swipe {
    height: 68px;
    line-height: 29px;
  }
</style>
